import { render, staticRenderFns } from "./patternsList.vue?vue&type=template&id=b36b8150&scoped=true"
import script from "./patternsList.vue?vue&type=script&lang=js"
export * from "./patternsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b8150",
  null
  
)

export default component.exports